import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { PropsWithChildren } from "react";

import { cssAnchorProps } from "@/react/helpers/cssAnchorHelpers";

import { useWorkspaceBackgroundClass } from "./useWorkspaceBackgroundClass";

export const WorkspaceBackground = ({ children }: PropsWithChildren) => {
  const bgClass = useWorkspaceBackgroundClass();

  return (
    <div
      className={classNames("flex flex-1 flex-col", bgClass)}
      {...cssAnchorProps({ anchor: "app-content" })}
    >
      {children}
    </div>
  );
};
